// extracted by mini-css-extract-plugin
module.exports = {"section":"description_section__iRzjP","container":"description_container__6CYG_"};